import { getEnabledFeatures } from './getEnabledFeatures'

export async function hasFeaturePermission(hoaID, permissionName) {
  const results = await getEnabledFeatures(hoaID)

  console.log(hoaID + ', in hasFeaturePermission..................' + getEnabledFeatures(hoaID))
  console.debug(hoaID + ', in hasFeaturePermission..................' + JSON.stringify(results))

  let permissionSet = false

  if (results !== undefined && results) {
    const filtered = results.filter(f => f === permissionName)[0]
    if (filtered !== undefined && filtered) {
      permissionSet = true
    }
  }

  console.debug('checking ' + permissionName + ' = ' + permissionSet)

  return permissionSet
}
